import { render, staticRenderFns } from "./SalesmanDetail.vue?vue&type=template&id=3c0ff5f0&scoped=true"
import script from "./SalesmanDetail.vue?vue&type=script&lang=js"
export * from "./SalesmanDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesmanDetail.vue?vue&type=style&index=0&id=3c0ff5f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ff5f0",
  null
  
)

export default component.exports